{
  "R": [13, 156, 237, 240],
  "G": [8, 23, 121, 249],
  "B": [135, 158, 83, 33],
  "A": [0, 56, 80, 88],
  "I": [0, 64, 192, 255]
}
